module.exports = __webpack_public_path__ + "static/media/pic1.c7b42c9f.jpg";